var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#CCFFCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5608 9.56264L11.6476 17.4753C11.0616 18.0614 10.111 18.0614 9.5245 17.4753L5.43965 13.3901C4.85345 12.8041 4.85345 11.8534 5.43965 11.2672C6.02597 10.6809 6.97645 10.6809 7.56251 11.267L10.5864 14.2908L17.4376 7.43957C18.0239 6.85325 18.9745 6.8537 19.5606 7.43957C20.1466 8.02577 20.1466 8.97611 19.5608 9.56264Z",
    fill: "#1F7B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedIcon);
export default __webpack_public_path__ + "static/media/passed-icon.b22aefdf5fcad749b041a35939e7a5f7.svg";
export { ForwardRef as ReactComponent };